import React, { useCallback, useEffect, useState } from 'react'

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BiCheck } from "react-icons/bi";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// API
import { getCustomerCities, getCustomerCountries, getCustomerStates } from 'utlis/Apis/Customers_API';

// react toastify
import { toast } from 'react-toastify';

function CheckoutStepOne(props) {
    // props
    const {
        cartDetails,

        allCheckoutDetails,
        setAllCheckoutDetails,

        checkoutCurrentStep,
        setCheckoutCurrentStep,

        completedcheckoutSteps,
        setCompletedCheckoutSteps,

        userAddress,
        setUserAddress,

        userShippingAddress,
    } = props

    // consts
    const DEFAULT_COUNTRY_TEMP = "254"

    // states
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [sectionLoading, setSectionLoading] = useState(false)
    const [selectedAddressId, setSelectedAddressId] = useState("")
    const [currentAddress, setCurrentAddress] = useState(null)

    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])


    // extract city by id
    const extractCityById = cityId => {
        if (cityId) {
            if (!cities?.length) return;
            const city = cities.find(item => item.city_id === parseInt(cityId))

            return city?.city ?? ""
        }
    }

    // extract state by id
    const extractStateById = stateId => {
        if (stateId) {
            if (!states?.length) return;

            const state = states.find(item => item.region_id === parseInt(stateId))

            return state?.region ?? ""
        }
    }

    // extract country by id
    const extractCountryById = countryId => {
        if (countryId) {
            if (!countries?.length) return;

            const country = countries.find(item => item.country_id === parseInt(countryId))

            return country?.country ?? ""
        }
    }

    // initial form values
    const initialFormValues = {
        companyName: "",
        country: DEFAULT_COUNTRY_TEMP,
        state: '',
        city: '',
        zipCode: '',
        firstName: '',
        lastName: '',
        address: '',
        address1: '',
        phone: '',
        isDefault: false
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        companyName: Yup.string(),
        // country: Yup.string().required('This field is required'),
        country: Yup.string(),
        state: Yup.string().required('This field is required'),
        city: Yup.string().required('This field is required'),
        zipCode: Yup.string().required('This field is required'),
        firstName: Yup.string().required('This field is required'),
        lastName: Yup.string().required('This field is required'),
        address: Yup.string().required('This field is required'),
        address1: Yup.string(),
        phone: Yup.string()
            .min(10, "Invalid phone number")
            .max(12, "Invalid phone number")
            .required('This field is required'),
        isDefault: Yup.boolean(),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            const addressToShow = `${values.address}, ${values.address1 ? values.address1 + "," : ""} ${extractCityById(values.city)}, ${extractStateById(values.state)}, ${values.zipCode}, ${extractCountryById(DEFAULT_COUNTRY_TEMP)}`

            setUserAddress(addressToShow) // setting address to show if the step is complete

            setAllCheckoutDetails({ // setting checkout details
                ...allCheckoutDetails,
                shippingAddressDetails: {
                    shipping_first_name: values.firstName,
                    shipping_middle_name: "",
                    shipping_last_name: values.lastName,
                    shipping_company_name: values.companyName,
                    shipping_address: values.address,
                    shipping_address1: values.address1,
                    shipping_city: values.city,
                    // shipping_country: values.country,
                    shipping_country: DEFAULT_COUNTRY_TEMP,
                    shipping_state: values.state,
                    shipping_zipcode: values.zipCode,
                    shipping_mobile: values.phone,
                    shipping_fax: "",
                    is_default: values.isDefault ? "1" : "0",
                    address_id: selectedAddressId,

                    addressToShow
                }
            })

            setCompletedCheckoutSteps([...completedcheckoutSteps, "step1"]) // setting completed steps

            setCheckoutCurrentStep("step2") // setting current step

            window.scrollTo(0, 0) // scrolling windows to the top
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // get countries
    const getCountries = useCallback((callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerCountries().then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            if (resData.success) {
                setCountries(resData.data)

                // callback
                callBack()
            }
            if (resData.error) {
                console.log('Error occured while loading countries', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCountries api ", err);
        })
    }, [])

    // get states
    const getStates = useCallback((countryId, callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        // getCustomerStates(countryId).then(res => {
        getCustomerStates(DEFAULT_COUNTRY_TEMP).then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            if (resData.success) {
                setStates(resData.data)

                formik.setFieldValue("city", "")

                // callback
                callBack()

                if (!resData?.data?.length) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.info("No city found from the selected state", {
                        autoClose: 2500,
                    });
                }

            }
            if (resData.error) {
                console.log('Error occured while loading countries', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCountries api ", err);
        })
    }, [])

    // get states
    const getCities = (regionId, callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerCities(regionId).then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            if (resData.success) {
                setCities(resData.data)

                // callback
                callBack()

                if (!resData?.data?.length) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.info("No city found from the selected state", {
                        autoClose: 2500,
                    });
                }
            }
            if (resData.error) {
                console.log('Error occured while loading countries', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCountries api ", err);
        })
    }

    // choose address
    const chooseAddress = addressItem => {
        if (addressItem && Object.keys(addressItem)?.length) { // if object exists
            setCurrentAddress(addressItem) // setting current selected address

            setSelectedAddressId(addressItem.addressId) // setting current selected address id

            formik.setFieldValue("zipCode", addressItem.zipCode) // setting zipCode name
            formik.setFieldValue("firstName", addressItem.firstName) // setting firstName name
            formik.setFieldValue("lastName", addressItem.lastName) // setting lastName name
            formik.setFieldValue("address", addressItem.address) // setting address name
            formik.setFieldValue("address1", addressItem.address1) // setting address name
            formik.setFieldValue("phone", addressItem.phone) // setting phone name
            formik.setFieldValue("companyName", addressItem.companyName) // setting companyName name
            formik.setFieldValue("isDefault", (addressItem.isDefault === "0") ? false : true) // setting companyName name

            formik.setFieldValue("country", DEFAULT_COUNTRY_TEMP) // setting country name
            getStates(DEFAULT_COUNTRY_TEMP, () => { // callback
                formik.setFieldValue("state", addressItem.stateId) // setting state name
                getCities(addressItem.stateId, () => { // callback
                    formik.setFieldValue("city", addressItem.cityId) // setting city name

                    formik.submitForm() // submits the form
                    window.scrollTo(0, 0) // scrolling windows to the top

                }) // getting city
            }) // getting state
        } else {
            // resetting the form
            formik.resetForm()

            setSelectedAddressId("") // setting current selected address id
        }
    }

    // getting countries
    useEffect(() => {
        if (checkoutCurrentStep === "step1" && currentAddress === null) {
            getCountries(() => { // callback
                if (cartDetails && Object.keys(cartDetails)?.length) {
                    const mainAddress = {
                        zipCode: cartDetails.ship_zipcode,
                        firstName: cartDetails.ship_first_name,
                        lastName: cartDetails.ship_last_name,
                        address: cartDetails.ship_address,
                        address1: cartDetails.ship_address1,
                        phone: cartDetails.ship_mobile,
                        companyName: cartDetails.ship_company_name,
                        isDefault: cartDetails.ship_is_default ? 1 : 0,
                        stateId: cartDetails.ship_state,
                        cityId: cartDetails.ship_city,
                    }

                    // setting address details
                    chooseAddress(mainAddress)
                }
            })
        }
    }, [
        checkoutCurrentStep,
        currentAddress,
        getCountries,
        cartDetails
    ])

    // when user wants to change address
    const handleChangeAddress = (ev) => {
        ev.preventDefault()
        // const updatedSteps = completedcheckoutSteps.filter(item => item !== "step1")

        setCompletedCheckoutSteps([])
    }

    // country change
    const handleCountryChange = (ev) => {
        const inpVal = ev.target.value
        if (inpVal) {
            getStates(inpVal)
        }
    }

    // state change
    const handleStateChange = (ev) => {
        const inpVal = ev.target.value
        if (inpVal) {
            getCities(inpVal)
        }
    }

    return (
        <React.Fragment>
            {
                completedcheckoutSteps?.length && completedcheckoutSteps.find(item => item === "step1") ? (
                    <div className="after-header border-bottom pb-3 mb-3">
                        <div className="ah-inner d-flex">
                            <div className="check me-3 d-flex align-items-center justify-content-center">
                                <BiCheck fontSize={23} color={"#333"} />
                            </div>
                            <div className="content media-body st-fs-15">
                                <p className="head st-fw-600 mb-0">Address</p>
                                <p className="info mb-0">
                                    <span className="st-fw-600">{userAddress}</span>
                                    {/* <span className="ms-3 st-fs-14 cursor-pointer" onClick={handleChangeAddress}>Change Address</span> */}
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="content-view mb-3">
                        <div className="cv-inner">
                            <div className="head-container mb-3">
                                <p className="head mb-1 st-fs-25">
                                    <span>Shipping & Delivery</span>
                                </p>
                                <p className="desc mb-0">Enter your shipping address. All fields are required unless they’re explicitly marked as optional.</p>
                            </div>

                            <div className="form-content position-relative step1">
                                <form
                                    onSubmit={formik.handleSubmit}
                                    noValidate
                                    autoComplete="off">
                                    <div className="d-flex flex-wrap">
                                        <div className="form-lt">
                                            <label className="mb-1">First Name <span className="st-fs-12">(required)</span></label>
                                            <input
                                                type="text"
                                                placeholder="First Name"
                                                {...formik.getFieldProps('firstName')}
                                                disabled={true}
                                            />
                                            {
                                                (formik.touched.firstName && formik.errors.firstName) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.firstName}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-rt">
                                            <label className="mb-1">Last Name <span className="st-fs-12">(required)</span></label>
                                            <input
                                                type="text"
                                                placeholder="Last Name"
                                                {...formik.getFieldProps('lastName')}
                                                disabled={true}
                                            />
                                            {
                                                (formik.touched.lastName && formik.errors.lastName) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.lastName}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-ct">
                                            <label className="mb-1">Company Name</label>
                                            <input
                                                type="text"
                                                placeholder="Company Name"
                                                {...formik.getFieldProps('companyName')}
                                                disabled={true}
                                            />
                                            {
                                                (formik.touched.companyName && formik.errors.companyName) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.companyName}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-ct">
                                            <label className="mb-1">Country <span className="st-fs-12">(required)</span></label>
                                            <select
                                                {...formik.getFieldProps('country')}
                                                onChange={ev => {
                                                    formik.handleChange(ev)
                                                    handleCountryChange(ev)
                                                }}
                                                disabled={true} // disabled for now
                                            >
                                                <option disabled value="choose">Please choose</option>
                                                {
                                                    countries?.length ? countries.map(item => (
                                                        <React.Fragment key={item.country_id}>
                                                            <option value={item.country_id}>{item.country}</option>
                                                        </React.Fragment>
                                                    )) : null
                                                }
                                            </select>
                                            {
                                                (formik.touched.country && formik.errors.country) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.country}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-lt">
                                            <label className="mb-1">State <span className="st-fs-12">(required)</span></label>
                                            <select
                                                // className={(formik?.values?.country?.length === 0) ? "disabled" : ""}
                                                // disabled={(formik?.values?.country?.length === 0)}
                                                {...formik.getFieldProps('state')}
                                                onChange={ev => {
                                                    formik.handleChange(ev)
                                                    handleStateChange(ev)
                                                }}
                                                disabled={true}
                                            >
                                                <option disabled value="">Please choose</option>
                                                {
                                                    states?.length ? states.map(item => (
                                                        <React.Fragment key={item.region_id}>
                                                            <option value={item.region_id}>{item.region}</option>
                                                        </React.Fragment>
                                                    )) : null
                                                }
                                            </select>
                                            {
                                                (formik.touched.state && formik.errors.state) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.state}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-rt">
                                            <label className="mb-1">City <span className="st-fs-12">(required)</span></label>
                                            <select
                                                // className={((formik?.values?.country?.length === 0) || (formik?.values?.state?.length === 0)) ? "disabled" : ""}
                                                // disabled={((formik?.values?.country?.length === 0) || (formik?.values?.state?.length === 0))}
                                                className={((formik?.values?.state?.length === 0)) ? "disabled" : ""}
                                                // disabled={((formik?.values?.state?.length === 0))}
                                                disabled={true}
                                                {...formik.getFieldProps('city')}
                                            >
                                                <option disabled value="choose">Please choose</option>
                                                {
                                                    cities?.length ? cities.map(item => (
                                                        <React.Fragment key={item.city_id}>
                                                            <option value={item.city_id}>{item.city}</option>
                                                        </React.Fragment>
                                                    )) : null
                                                }
                                            </select>
                                            {
                                                (formik.touched.city && formik.errors.city) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.city}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-ct">
                                            <label className="mb-1">Address <span className="st-fs-12">(required)</span></label>
                                            <input
                                                type="text"
                                                placeholder="Address"
                                                {...formik.getFieldProps('address')}
                                                disabled={true}
                                            />
                                            {
                                                (formik.touched.address && formik.errors.address) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.address}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-ct">
                                            <label className="mb-1">Address 2</label>
                                            <input
                                                type="text"
                                                placeholder="Address 2"
                                                {...formik.getFieldProps('address1')}
                                                disabled={true}
                                            />
                                            {
                                                (formik.touched.address1 && formik.errors.address1) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.address1}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-lt">
                                            <label className="mb-1">Zip Code <span className="st-fs-12">(required)</span></label>
                                            <input
                                                type="text"
                                                placeholder="Zip Code"
                                                {...formik.getFieldProps('zipCode')}
                                                disabled={true}
                                            />
                                            {
                                                (formik.touched.zipCode && formik.errors.zipCode) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.zipCode}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-rt">
                                            <label className="mb-1">Phone <span className="st-fs-12">(required)</span></label>
                                            <input
                                                type="number"
                                                placeholder="Phone"
                                                {...formik.getFieldProps('phone')}
                                                disabled={true}
                                            />
                                            {
                                                (formik.touched.phone && formik.errors.phone) ? (
                                                    <div className="error-msg st-fs-12 text-danger position-absolute">
                                                        {formik.errors.phone}
                                                    </div>
                                                ) : null
                                            }
                                        </div>

                                        <div className="form-ct">
                                            <label className="st-default-checkbox d-inline-flex">
                                                <input
                                                    type="checkbox"
                                                    className="d-none mb-0"
                                                    checked={formik.getFieldProps('isDefault').value}
                                                    {...formik.getFieldProps('isDefault')}
                                                    disabled={true}
                                                />
                                                <span className="checkbox d-flex align-items-center justify-content-center">
                                                    <BiCheck />
                                                </span>
                                                <span className="text ps-2">
                                                    Set as Default
                                                </span>
                                            </label>
                                        </div>

                                        {/* btns */}
                                        <div className="btns w-100 pt-2">
                                            <button type="submit" className="btn" disabled={btnDisabled}>
                                                {
                                                    btnLoading ? (
                                                        <Spinner animation="border" size="sm" />
                                                    ) : (
                                                        <span>Continue</span>
                                                    )
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                {
                                    /* LOADING */
                                    sectionLoading ? (
                                        <div className="section-loading position-absolute align-items-center d-flex h-100 justify-content-center section-loading w-100" style={{ top: 0, left: 0, background: "rgba(255,255,255,0.5)" }}>
                                            <Spinner animation="border" />
                                        </div>
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>
                )
            }


        </React.Fragment>
    )
}

export default CheckoutStepOne;